import { z } from 'zod';

export const SavedAnswer = z.object({
  id: z.string().uuid(),
  value: z.union([z.string(), z.array(z.string()), z.null()]),
  date: z.number().optional()
});
